<template>
	<div>
		<div>
			<h3>Référentiel</h3>
			<nested-draggable :tasks="list" :parameters="parameters" />
			<b-button
				@click="
					list.push({
						id: unique_id(),
						data: {},
						tasks: [],
						show: true,
						first_deep: 0,
					})
				"
				>Ajouter</b-button
			>
		</div>
	</div>
</template>

<script>
	import nestedDraggable from "./nested-draggable";
	import uniqueId from "lodash.uniqueid";

	export default {
		name: "draggable_tree",
		display: "Nested",
		order: 15,
		components: {
			nestedDraggable,
		},
		props: {
			parameters: {
				type: Object,
			},
		},
		data() {
			return {
				list: [],
			};
		},
		watch: {
			list: {
				deep: true,
				handler: function () {
					//console.log("watch")
					this.setDeep(this.list, 0);
					this.$emit("update", this.list);
				},
			},
		},
		methods: {
			setDeep(list, deep) {
				for (var i = 0; i < list.length; i++) {
					list[i].deep = deep;
					this.setDeep(list[i].tasks, deep + 1);
				}
			},
			unique_id() {
				return uniqueId();
			},
			set(list) {
				this.list = list;
			},
		},
	};
</script>
<style scoped></style>
